import React, { useEffect, useState } from "react";
import Header from "../../../components/landingPage/Header";
import { useSelector, useDispatch } from "react-redux";
import SideBar from "../../../components/b2b/SideBar";
import Modal from "../../../components/b2b/Modal";
import { GoogleMap, LoadScript, Polygon } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import {
  PencilIcon,
  PlusIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import LoadingIcon from "../../../components/loading/LoadingIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faTrash,
} from "@fortawesome/fontawesome-free-solid";
import {
  flatRegionPageCountDecrease,
  flatRegionPageCountIncrease,
} from "../../../redux/app/map/map-slice";
import { faX } from "@fortawesome/free-solid-svg-icons";
import {
  setFlatRegionToBeDelete,
  setOpenDeleteModal,
} from "../../../redux/app/regions/region-slice";
import Select from "react-select";
import { X } from "@mui/icons-material";

const FlatRegions = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { flatRegions, flatPriorityRegions } = useSelector(
    (state) => state.region
  );
  const { flatRegionPageCount, totalFlatRegions, regionLoading } = useSelector(
    (state) => state.map
  );
  const [regionNameInput, setregionNameInput] = useState();
  const [delModal, setdelModal] = useState(false);
  const [flatRegionsListdata, setflatRegions] = useState([]);
  const [selectFlatPriorityRegion, setselectFlatPriorityRegion] = useState();
  const [openPriorityRegion, setopenPriorityRegion] = useState(false);

  const flatRegionsList = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/flatregions/getAllFlatRegionsList`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();

    data?.regionData?.forEach((region) => {
      setflatRegions((prev) => [
        ...prev,
        { value: region?._id, label: `${region?.name}` },
      ]);
      // options.unshift({ value: region._id, label: `${region.name} flatrate` });
      // console.log(region.name + " flatrate", "region");
      // options.push({ value: region._id, label: `${region.name} flatrate` });
    });
  };

  useEffect(() => {
    flatRegionsList();
  }, []);

  useEffect(() => {
    dispatch({
      type: "GET_FLAT_REGIONS",
      payload: { token, page: flatRegionPageCount },
    });
  }, [flatRegionPageCount]);

  const handleCreatePriorityRegion = () => {
    dispatch({
      type: "CREATE_PRIORITY_REGION_FLATREGION",
      payload: {
        token,
        body: selectFlatPriorityRegion,
      },
    });
  };

  useEffect(() => {
    dispatch({
      type: "GET_PRIORITY_REGIONS",
      payload: {
        token,
      },
    });
  }, []);

  // GET_FLAT_REGION_OR_SEARCH

  useEffect(() => {
    if (regionNameInput?.length > 2) {
      const regionTimer = setTimeout(() => {
        dispatch({
          type: "GET_FLAT_REGION_OR_SEARCH",
          payload: {
            regionName: regionNameInput,
            token,
          },
        });
      }, 500);

      return () => clearTimeout(regionTimer);
    } else if (regionNameInput?.length === 0) {
      dispatch({
        type: "GET_FLAT_REGIONS",
        payload: { token, page: flatRegionPageCount },
      });
    }

    // if (regionNameInput?.length === 0) {
    //   dispatch({ type: "GET_FLAT_REGIONS", payload: {token, page: flatRegionPageCount } });
    // }
  }, [regionNameInput, dispatch]);

  return (
    <>
      <div className="fixed w-screen h-screen">
        <Header token={token} />
        <div className="flex">
          <SideBar />
          <div className="w-screen mb-5">
            <div className="flex space-x-4 px-10 justify-between">
              <div className="py-1 ">
                <div className="text-sm font-semibold text-gray-700">
                  Search by region
                </div>
                <div className="flex ">
                  <input
                    onChange={(e) => setregionNameInput(e.target.value)}
                    type="text"
                    className="border-b-2 focus:outline-none textField w-52"
                    placeholder="Search"
                  />

                  {regionLoading && (
                    <div>
                      <LoadingIcon />
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-end space-x-3 relative">
                {openPriorityRegion && (
                  // create a modal with  select input to select the priority region
                  <div className="bg-gray-100 px-2 border border-gray-300 rounded-md w-80 h-72 absolute z-50 top-0 backdrop-blur-md shadow-lg">
                    <div className=" space-y-2 pt-1">
                      <div className="flex justify-between items-center">
                        <div className="text-sm text-gray-500">
                          Set Priority Regions
                        </div>
                        <XCircleIcon
                          onClick={() => {
                            setopenPriorityRegion(false);
                          }}
                          className="w-5 text-secondary cursor-pointer"
                        />
                      </div>
                      <div className="flex space-x-2 items-center flex-1">
                        <Select
                          className="w-50 flex-1"
                          options={flatRegionsListdata}
                          onChange={(e) => {
                            setselectFlatPriorityRegion({
                              name: e.label,
                              regionType: "flatregion",
                              flatRegionId: e.value,
                            });
                          }}
                        />
                        <button
                          onClick={handleCreatePriorityRegion}
                          className="px-1 py-1 rounded-md bg-red-400 text-white"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                    <div className="text-lg text-gray-700 border-b-2 pt-2">
                      Priority Regions
                    </div>
                    <div className="h-44 overflow-y-auto scrollbar space-y-1">
                      {flatPriorityRegions?.map((item) => {
                        return (
                          <div className="flex justify-between items-center py-1 bg-white rounded-md shadow-md px-2">
                            <div className="text-sm text-gray-500">
                              {item?.name}
                            </div>
                            {/* add delete */}
                            {/* <button className="text-red-400 hover:text-red-600"> */}
                            <TrashIcon
                              onClick={() => {
                                dispatch({
                                  type: "DELETE_PRIORITY_REGION",
                                  payload: {
                                    token,
                                    id: item?._id,
                                  },
                                });
                              }}
                              className="text-red-400 w-6 rounded-full px-1 py-1 hover:bg-slate-100 cursor-pointer"
                            />
                            {/* </button> */}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                <button
                  onClick={() => {
                    setopenPriorityRegion(true);
                  }}
                  className="px-2 py-2 space-x-3 text-white rounded-sm cursor-pointer bg-secondary hover:bg-[#fb4156] hover:shadow-md"
                >
                  Priority Regions
                </button>
                <Link to="/flatregions/create">
                  <button className="flex items-center justify-end px-2 py-2 space-x-3 text-white rounded-sm cursor-pointer bg-secondary hover:bg-[#fb4156] hover:shadow-md">
                    <PlusIcon className="block w-5 h-5" />
                    <div>Add Flat Region</div>
                  </button>
                </Link>
              </div>
            </div>
            <div className="flex space-x-3 pt-3 justify-between px-10">
              <div
                onClick={() => {
                  flatRegionPageCount > 1 &&
                    dispatch(flatRegionPageCountDecrease());
                }}
                className={`flex  space-x-2 items-center ${
                  flatRegionPageCount > 1 ? "cursor-pointer" : "text-gray-600"
                }  `}
              >
                <FontAwesomeIcon
                  icon={faArrowAltCircleLeft}
                  className={`flex  space-x-2 items-center ${
                    flatRegionPageCount > 1 ? "cursor-pointer" : "text-gray-600"
                  }  `}
                />
                <div className="">Prev</div>
              </div>
              <div className="flex items-start space-x-2">
                <div className="text-lg ">Page:</div>
                <div className="text-lg font-semibold">
                  {flatRegionPageCount} / {Math.ceil(totalFlatRegions / 20)}
                </div>
              </div>

              <div
                onClick={() => {
                  flatRegionPageCount < totalFlatRegions / 20 &&
                    dispatch(flatRegionPageCountIncrease());
                }}
                className={`flex space-x-2 items-center ${
                  flatRegionPageCount < Math.ceil(totalFlatRegions / 20)
                    ? "cursor-pointer"
                    : " text-gray-600"
                }  `}
              >
                <div>Next</div>
                <FontAwesomeIcon
                  icon={faArrowAltCircleRight}
                  className={`flex space-x-2 items-center ${
                    flatRegionPageCount < Math.ceil(totalFlatRegions / 20)
                      ? "cursor-pointer"
                      : " text-gray-600"
                  }  `}
                />
              </div>
            </div>
            <div className="h-screen pb-20 overflow-y-auto scrollbar">
              {flatRegions.length === 0 && (
                <div className="text-center flex justify-center items-center h-full">
                  {" "}
                  <LoadingIcon />{" "}
                </div>
              )}
              {flatRegions.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 rounded-t pb-20 ">
                  {flatRegions?.map((item) => {
                    console.log("item", item);
                    let x = 0;
                    let y = 0;
                    let z = 0;
                    let path = [];
                    let center;
                    item?.LocationPoints?.forEach((element) => {
                      path.push({
                        lat: element?.geometry?.location?.lat,
                        lng: element?.geometry?.location?.lng,
                      });
                    });

                    path?.forEach((element) => {
                      var latitude = (element?.lat * Math?.PI) / 180;
                      var longitude = (element?.lng * Math?.PI) / 180;

                      x += Math.cos(latitude) * Math.cos(longitude);
                      y += Math.cos(latitude) * Math.sin(longitude);
                      z += Math.sin(latitude);
                    });

                    var total = path?.length;

                    x = x / total;
                    y = y / total;
                    z = z / total;

                    var centralLongitude = Math.atan2(y, x);
                    var centralSquareRoot = Math.sqrt(x * x + y * y);
                    var centralLatitude = Math.atan2(z, centralSquareRoot);

                    center = {
                      lat: (centralLatitude * 180) / Math.PI,
                      lng: (centralLongitude * 180) / Math.PI,
                    };

                    return (
                      <>
                        {delModal && (
                          <>
                            <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
                            <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
                              <div className="relative w-1/2 max-w-3xl mx-auto my-6">
                                {/*content*/}
                                <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                                  {/*header*/}
                                  <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-slate-200">
                                    <h3 className="text-2xl font-medium text-[#fb4156]">
                                      Delete Region
                                    </h3>
                                  </div>
                                  <div className="text-xl font-medium py-3 mx-5">
                                    Do you want to delete this Region?
                                  </div>

                                  <div className="flex justify-end mx-3 space-x-3">
                                    <button
                                      className="mb-5  flex items-center justify-end px-2 py-2 space-x-3 text-black rounded-sm cursor-pointer border border-primary"
                                      type="button"
                                      onClick={() => {
                                        setdelModal(false);
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        className="block w-5 mr-2"
                                        icon={faX}
                                      />
                                      Cancel
                                    </button>
                                    <button
                                      className="mb-5  flex items-center justify-end px-2 py-2 space-x-3 text-white rounded-sm cursor-pointer bg-secondary hover:bg-red-600 hover:shadow-md"
                                      type="button"
                                      onClick={() => {
                                        dispatch({
                                          type: "DELETE_FLAT_REGION",
                                          payload: {
                                            id: item?._id,
                                            token: token,
                                          },
                                        });
                                        setdelModal(false);
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        className="block w-5 mr-2"
                                        icon={faTrash}
                                      />
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        <FlatRegionItem
                          subpaths={item?.subRegions}
                          paths={path}
                          center={center}
                          regionname={item?.name}
                          regionId={item?._id}
                          onClickDelete={() => {
                            setdelModal(true);
                          }}
                        />
                      </>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlatRegions;

export const FlatRegionItem = ({
  subpaths,
  paths,
  center,
  regionname,
  regionId,
  onClickDelete,
}) => {
  const containerStyle = {
    width: "100%",
    height: "300px",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
  };

  const options = {
    fillColor: "#39121739",
    fillOpacity: 1,
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };
  const dispatch = useDispatch();
  // const deleteModalRef = useRef(false);
  // const [deleteRegionModal, setdeleteRegionModal] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const { openDeleteModal, flatRegionToBeDelete } = useSelector(
    (state) => state.region
  );
  const [regionIdToBeDelete, setregionIdToBeDelete] = useState();

  console.log(regionIdToBeDelete, "item to be delete");
  //
  return (
    <>
      <div className="m-5">
        {openDeleteModal && (
          <>
            {/* <div className="fixed top-0 left-0 w-screen h-screen bg-red-100 bg-opacity-10 z-10 flex justify-center items-center"></div> */}
            <Modal
              addOnClick={() => {
                dispatch({
                  type: "DELETE_FLAT_REGION",
                  payload: {
                    id: flatRegionToBeDelete?.id,
                    token: token,
                  },
                });
                dispatch(
                  setOpenDeleteModal({
                    openDeleteModal: false,
                  })
                );
              }}
              addButtonLabel="Yes"
              heading={`Delete ${flatRegionToBeDelete?.name}`}
              isDeleteRegion={true}
              cancelOnClick={() => {
                dispatch(
                  setOpenDeleteModal({
                    openDeleteModal: false,
                  })
                );
              }}
            />
          </>
        )}
        <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={8}
          >
            {/* Child components, such as markers, info windows, etc. */}
            {subpaths &&
              Object.values(subpaths).map((subRegion) => {
                return (
                  <Polygon
                    // onLoad={onLoad}
                    paths={subRegion?.map((item) => {
                      return {
                        lat: item?.geometry?.location?.lat,
                        lng: item?.geometry?.location?.lng,
                      };
                    })}
                    options={options}
                  />
                );
              })}
            <Polygon
              // onLoad={onLoad}
              paths={paths}
              options={options}
            />
          </GoogleMap>
        </LoadScript>
        <div className="flex items-center justify-between px-3 py-1 mt-1 bg-gray-200 rounded-b-md">
          <div className="py-1 font-semibold text-center text-gray-700 text-md ">
            {regionname}
          </div>
          <div className="flex spacex-x-5 items-center">
            <Link to={`/flatregions/edit/${regionId}`}>
              <PencilIcon className="text-gray-700 cursor-pointer hover:bg-[#fb4156] rounded-full w-8 h-8 p-0.5 hover:text-gray-50 transition duration-300 ease-in-out" />
            </Link>
            <TrashIcon
              className="text-red-500 w-6 h-6 cursor-pointer"
              onClick={() => {
                dispatch(
                  setFlatRegionToBeDelete({
                    flatRegionToBeDelete: {
                      id: regionId,
                      name: regionname,
                    },
                  })
                );
                dispatch(
                  setOpenDeleteModal({
                    openDeleteModal: true,
                  })
                );
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
